'use client';
import { useState, ReactNode } from 'react';
import Image from 'next/image';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '@/components/CustomRichText';

interface AchievementItemProps {
  achievementItem: {
    icon?: string | { url: string; alt: string };
    title: ReactNode | SerializedEditorState;
    subtitleImg: string | { url: string; alt: string };
    hoverTxt?: ReactNode | SerializedEditorState;
    width?: number;
    height?: number;
  };
  swiperRef: React.RefObject<any>;
}

export default function AchievementItemV4({ achievementItem, swiperRef }: AchievementItemProps) {
  const [isClicked, setIsClicked] = useState(false);
  const handleClick = () => {
    setIsClicked(prev => {
      const newClickedState = !prev;
      if (newClickedState) {
        swiperRef.current.autoplay.stop();
      } else {
        swiperRef.current.autoplay.start();
      }
      return newClickedState;
    });
  };

  return (
    <div
      data-meta="AchievementItemV4"
      className={`achievement-item ${isClicked ? 'clicked' : ''}`}
      onClick={() => handleClick()}
    >
      <div className="achievement-inner">
        <div className="achievement-front">
          <CustomRichText
            data={achievementItem.title}
            tag="div"
            className="font-fixel text-ellipsis text-center font-bold text-white flex justify-center items-center h-20 w-52 border-b"
          />
          {achievementItem.subtitleImg ? (
            <Image
              width={150}
              height={150}
              alt={
                typeof achievementItem.subtitleImg === 'string'
                  ? ''
                  : achievementItem.subtitleImg.alt
              }
              src={
                typeof achievementItem.subtitleImg === 'string'
                  ? achievementItem.subtitleImg
                  : achievementItem.subtitleImg.url
              }
              className="mx-auto h-20 w-auto"
            />
          ) : (
            <div className="h-20 w-auto"></div>
          )}
        </div>
        <div
          className={
            'bg-white rounded-full achievement-back ' +
            (!achievementItem.hoverTxt ? 'achievement-back--large' : '')
          }
        >
          {achievementItem.icon && (
            <Image
              width={achievementItem.width || 150}
              height={achievementItem.height || 150}
              src={
                typeof achievementItem.icon === 'string'
                  ? achievementItem.icon
                  : achievementItem.icon.url
              }
              alt={typeof achievementItem.icon === 'string' ? '' : achievementItem.icon.alt}
              className="object-contain"
            />
          )}
          {achievementItem.hoverTxt && (
            <CustomRichText
              data={achievementItem.hoverTxt}
              tag="div"
              className="font-fixel text-center font-bold text-black"
            />
          )}
        </div>
      </div>
    </div>
  );
}
